/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Select from "react-select";
import './PatientFilterModal.css';  // Import the new CSS file

const genderOptions = [
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" }
];

const patientTypeOptions = [
    { label: "New", value: "New" },
    { label: "FollowUp", value: "FollowUp" },
    { label: "Reported", value: "Reported" }
];

const bmiOptions = [
    { label: "Less than 18.5", value: "Less than 18.5" },
    { label: "BMI 18.5-24.9", value: "BMI 18.5-24.9" },
    { label: "BMI 25-29.9", value: "BMI 25-29.9" },
    { label: "BMI 30-34.9", value: "BMI 30-34.9" },
    { label: "BMI 35-39.9", value: "BMI 35-39.9" },
    { label: "Above 40 or higher", value: "Above 40 or higher" }
];

const statusOptions = [
    { label: "Scheduled", value: "Scheduled" },
    { label: "Completed", value: "Completed" },
    { label: "Cancelled", value: "Cancelled" }
];

const ageOptions = Array.from({ length: 100 }, (_, i) => ({ label: i + 1, value: i + 1 }));

const PatientFilterModal = ({ show, handleClose, filters, starStatusList }) => {
    console.log(starStatusList, "-------------starStatusList")
    const [selectedFilters, setSelectedFilters] = useState([]);
    const [startAge, setStartAge] = useState(null);
    const [endAge, setEndAge] = useState(null);
    const [gender, setGender] = useState([]);
    const [patientType, setPatientType] = useState([]);
    const [starStatus, setStarStatus] = useState([]);
    const [bmi, setBmi] = useState([]);

    const removeFilter = (obj) => {
        const { filter, value } = obj
        const updatedFilters = selectedFilters.filter((obj) => obj.filter !== filter && obj.value !== value);
        setSelectedFilters(updatedFilters)

        switch (filter) {
            case "StartAge":
                setStartAge(null);
                break;
            case "EndAge":
                setEndAge(null);
                break;
            case "Gender":
                setGender(gender.filter(g => g.value !== value));
                break;
            case "PatientType":
                setPatientType(patientType.filter(pt => pt.value !== value));
                break;
            case "StarStatus":
                setStarStatus(starStatus.filter(ap => ap._id !== obj._id));
                break;
            case "BmiRange":
                setBmi(bmi.filter(b => b.value !== value));
                break;
            default:
                break;
        }
    };

    const handleStartAge = (option) => {
        setStartAge(option);

        setSelectedFilters(prevFilters => {
            const updatedFilters = prevFilters.filter(obj => obj.filter !== "StartAge");

            if (option?.value) {
                updatedFilters.push({ filter: "StartAge", value: option.value });
            }

            return updatedFilters;
        });
    };

    const handleEndAge = (option) => {
        setEndAge(option);

        setSelectedFilters(prevFilters => {
            const updatedFilters = prevFilters.filter(obj => obj.filter !== "EndAge");
            if (option?.value) {
                updatedFilters.push({ filter: "EndAge", value: option.value });
            }
            return updatedFilters;
        });
    };


    const handleAddPatientType = (options) => {
        const updatedFilters = selectedFilters.filter((obj) => obj.filter !== "PatientType");

        options.forEach((opt) => {
            updatedFilters.push({ filter: "PatientType", value: opt.value });
        });

        setSelectedFilters(updatedFilters);
    };

    const handleBmiRange = (options) => {
        const updatedFilters = selectedFilters.filter((obj) => obj.filter !== "BmiRange");

        options.forEach((opt) => {
            updatedFilters.push({ filter: "BmiRange", value: opt.value });
        });

        setSelectedFilters(updatedFilters);
    };

    const handleGender = (options) => {
        const updatedFilters = selectedFilters.filter((obj) => obj.filter !== "Gender");

        options.forEach((opt) => {
            updatedFilters.push({ filter: "Gender", value: opt.value });
        });

        setSelectedFilters(updatedFilters);
    };

    const handleAppointmentStatus = (options) => {
        const updatedFilters = selectedFilters.filter((obj) => obj.filter !== "StarStatus");

        options.forEach((opt) => {
            updatedFilters.push({ ...opt, filter: "StarStatus", value: opt.value });
        });

        setSelectedFilters(updatedFilters);
    }

    function generateId() {
        let id = "";
        let characters =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (let i = 0; i < 8; i++) {
            id += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return id;
    }

    const handleSaveModal = () => {
        const updatedFilters = selectedFilters.map((ele) => ({ ...ele, category: "Patient", id: generateId() }))
        handleClose(updatedFilters)
    }

    useEffect(() => {
        if (filters) {
            const cloneGender = gender
            const clonePatientType = patientType
            const cloneStarStatus = starStatus
            const cloneBmi = bmi
            console.log(filters, starStatus, "AAAAAAAAAAAAAAAA")
            filters.map((ele) => {
                const { filter, value } = ele
                switch (filter) {
                    case "StartAge":
                        setStartAge({ label: value, value: value });
                        break;
                    case "EndAge":
                        setEndAge({ label: value, value: value });
                        break;
                    case "Gender":
                        {
                            cloneGender.push({ label: value, value: value })
                            break;
                        }
                    case "PatientType":
                        {

                            clonePatientType.push({ label: value, value: value })
                            break;
                        }
                    case "StarStatus":
                        {
                            cloneStarStatus.push({ ...ele, label: value, value: value })
                            break;
                        }
                    case "BmiRange":
                        {

                            cloneBmi.push({ label: value, value: value })
                            break;
                        }
                    default:
                        break;
                }
            })
            setGender(cloneGender)
            setStarStatus(cloneStarStatus)
            setPatientType(clonePatientType)
            setBmi(cloneBmi)
            setSelectedFilters(filters)
        }
    }, [])

    console.log(starStatus, "---starStatus")
    return (
        <Modal show={show} onHide={handleClose} centered dialogClassName="modal-lg">
            <Modal.Header closeButton className="bg-thumbcolor">
                <Modal.Title>Patient Filters</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="filter-container age-selector-width">
                    <div className="row self-mb-10">
                        <div className="col-md-6">
                            <label>Patient Age Range</label>
                            {/* <div className="age-range d-flex"> */}
                            <div className="age-range row">
                                <div className="col-md-6">
                                    <Select className="width-age-filed"
                                        options={ageOptions}
                                        value={startAge}
                                        onChange={(selectedValue) => handleStartAge(selectedValue)}
                                        placeholder="Start range"
                                        isClearable
                                    />
                                </div>
                                {/* <span className="mx-2 align-self-center">to</span> */}
                                <div className="col-md-6">
                                    <Select className="width-age-filed"
                                        options={ageOptions.filter(opt => !startAge || opt.value > startAge.value)}
                                        value={endAge}
                                        onChange={(selectedValue) => handleEndAge(selectedValue)}
                                        placeholder="End range"
                                        isClearable
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <label>Star Status</label>
                            <Select className="align-start"
                                options={starStatusList}
                                multi={true}
                                value={starStatus}
                                onChange={(selected) => {
                                    setStarStatus(selected || []);
                                    handleAppointmentStatus(selected);
                                }}
                                isClearable
                                isSearchable
                            />
                        </div>

                        {/* <div className="col-md-4">
                            <label>Patient Type</label>
                            <Select
                                options={patientTypeOptions}
                                multi={true}
                                value={patientType}
                                onChange={(selected) => {
                                    setPatientType(selected || [])
                                    handleAddPatientType(selected);
                                }}
                            />
                        </div> */}
                    </div>
                    <div className="row self-mb-10 margin-for-col">
                        <div className="col-md-3">
                            <label>Gender</label>
                            <Select
                                options={genderOptions}
                                multi={true}
                                value={gender}
                                onChange={(selected) => {
                                    setGender(selected || [])
                                    handleGender(selected);
                                }
                                }
                            />
                        </div>
                        <div className="col-md-9">
                            <label>BMI Range</label>
                            <Select
                                options={bmiOptions}
                                multi={true}
                                value={bmi}
                                onChange={(selected) => {
                                    setBmi(selected || []);
                                    handleBmiRange(selected);
                                }}
                                isClearable
                                isSearchable
                            />
                        </div>
                    </div>
                </div>

                <div className="selected-filters mt-3 badges-style d-flex self-gap-3">
                    {selectedFilters.map((obj, index) => (
                        <span key={index} className="filter-badge">
                            {obj?.filter}: {obj?.value}
                            <span className="remove-filter" onClick={() => removeFilter(obj)}> × </span>
                        </span>
                    ))}
                </div>
            </Modal.Body>
            <Modal.Footer className="p-10-15">
                <Button variant="primary" onClick={handleSaveModal}>Save</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PatientFilterModal;
